import './App.css';
import Simulateur from './components/Simulateur';

function App() {
 
  return (
      <Simulateur />
  );
}

export default App;
